// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3KoU2","colCheckbox":"styles_colCheckbox__2akxH"};